import React from "react";
import { Title } from "../open-title";
import { ScrollCard } from "../../components/ScrollCard";
import { useTranslation } from "react-i18next";
import "./styles.less";

export const logoLists = [
  [
    {
      title: "阿里云",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_aliyun.png",
      content: "阿里云",
    },
    {
      title: "GitLab",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_gitlab.png",
      content: "GitLab",
    },
    {
      title: "腾讯云",
      logo:
        "//files.authing.co/authing-website/open/applications/icon_tencent_cloud-2.png",
      content: "腾讯云",
    },
    {
      title: "飞书",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_feishu.png",
      content: "飞书",
    },
    {
      title: "华为云",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_huaweiyun.png",
      content: "华为云",
    },
    {
      title: "北森",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_beisen.png",
      content: "北森",
    },
    {
      title: "Notion",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_notion.png",
      content: "Notion",
    },
  ],
  [
    {
      title: "Jira",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_jirasoftwar.png",
      content: "Jira",
    },
    {
      title: "Moka",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_moka.png",
      content: "Moka",
    },
    {
      title: "飞连",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_feilian.png",
      content: "飞连",
    },
    {
      title: "JumpServer",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_jumpserver.png",
      content: "JumpServer",
    },
    {
      title: "Zoom",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_zoom.png",
      content: "Zoom",
    },
    {
      title: "AWS",
      logo: "//files.authing.co/authing-website/open/applications/logo_aws.png",
      content: "AWS",
    },
    {
      title: "Gerrit",
      logo:
        "//files.authing.co/authing-website/open/applications/gerrit-logo.png",
      content: "Gerrit",
    },
  ],
  [
    {
      title: "GitHub",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_github.png",
      content: "GitHub",
    },
    {
      title: "腾讯企业邮箱",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_tengxunqiyeyouxiang.png",
      content: "腾讯企业邮箱",
    },
    {
      title: "VMware",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_vmware_horizon.png",
      content: "VMware",
    },
    {
      title: "ShowMeBug",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_showmebug.png",
      content: "ShowMeBug",
    },
    {
      title: "KubeSphere",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_kubesphere.png",
      content: "KubeSphere",
    },
    {
      title: "DataEase",
      logo: "//files.authing.co/authing-website/open/applications/dataease.png",
      content: "DataEase",
    },
    {
      title: "WordPress",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_wordpress.png",
      content: "WordPress",
    },
  ],
  [
    {
      title: "Zabbix",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_zabbix 1.png",
      content: "Zabbix",
    },
    {
      title: "夜莺",
      logo:
        "//files.authing.co/authing-website/open/applications/nightingale.png",
      content: "夜莺",
    },
    {
      title: "AWS Kibana",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_kibana.png",
      content: "AWS Kibana",
    },
    {
      title: "Grafana",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_grafana.png",
      content: "Grafana",
    },
    {
      title: "石墨文档",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_shimowendang.png",
      content: "石墨文档",
    },
    {
      title: "Office365",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_office365.png",
      content: "Office365",
    },
    {
      title: "Harbor",
      logo: "//files.authing.co/authing-website/open/applications/harbor.png",
      content: "Harbor",
    },
  ],
];

export const Application = () => {
  const { t } = useTranslation();

  return (
    <div className="open-page-application">
      <Title title={t("open.application.title")} />
      <ScrollCard cardList={logoLists} />
    </div>
  );
};
